import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route } from 'react-router-dom';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';
import { routerReducer as routing } from 'react-router-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducer as form } from 'redux-form';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reducers from './reducers';
import { SET_CURRENT_USER } from './actions/actionTypes';

import Firebase, { FirebaseContext } from './firebase';
import AppThemeProvider from './styles/AppThemeProvider';

import './index.scss';

const combinedReducers = combineReducers({
  ...reducers,
  routing,
  form,
});

const getResetStateForUserSwitch = (state) => ({
  sidebar: state?.sidebar,
  countries: state?.countries,
  settings: state?.settings,
  notification: state?.notification,
  routing: state?.routing,
  form: state?.form,
});

const rootReducer = (state, action) => {
  if (action.type === SET_CURRENT_USER) {
    const previousUid = state?.user?.currentUser?.uid || null;
    const nextUid = action?.user?.uid || null;

    if (previousUid !== nextUid) {
      return combinedReducers(getResetStateForUserSwitch(state), action);
    }
  }

  return combinedReducers(state, action);
};

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <FirebaseContext.Provider value={Firebase}>
      <AppThemeProvider>
        <BrowserRouter>
          <Route component={App} />
        </BrowserRouter>
      </AppThemeProvider>
    </FirebaseContext.Provider>
  </Provider>
);

// CRA service worker (unchanged)
serviceWorker.register();
